import PropTypes from 'prop-types'
import SocialIcons from '../SocialIcons'
import Tags from '../Tags'
import { withTranslation } from '../../i18n'
import { prepareLink } from '../../api/utils'

const SocialsAndTags = ({
  others, socials, tags, partner, t
}) => (
  <>
    {others.length > 0 && (
    <div className="linksDiv">
      {others.map(link => (
        <a href={prepareLink(link)} className="descriptionLink" target="_blank" rel="noopener noreferrer" key={link}>
          {link}
        </a>
      ))}
    </div>
    )}
    <SocialIcons
      socials={socials}
      className="socials"
    />
    {tags.length > 0 && (
    <Tags
      className="tags"
      tags={tags}
    />
    )}
    {partner && (
      <div className="partnerDiv">
        <a href={partner.site} target="_blank" rel="noopener noreferrer" className="partnerSite">
          <img src={partner.logo} alt="partnerLogo" className="partnerLogo" />
        </a>
        <span>
          <p className="withSupport">{t('with_support')}</p>
          <a href={partner.site} target="_blank" rel="noopener noreferrer" className="partnerSite">
            {partner.name || partner.site}
          </a>
        </span>
      </div>
    )}
  </>
)

SocialsAndTags.propTypes = {
  t: PropTypes.func.isRequired,
  others: PropTypes.arrayOf(String),
  socials: PropTypes.instanceOf(Object),
  partner: PropTypes.instanceOf(Object),
  tags: PropTypes.arrayOf(Object)
}
SocialsAndTags.defaultProps = {
  others: [],
  socials: {},
  partner: null,
  tags: []
}

export default withTranslation(['artists'])(SocialsAndTags)
